import { render, staticRenderFns } from "./CompleteOtherForms.vue?vue&type=template&id=25c2aecb"
import script from "./CompleteOtherForms.vue?vue&type=script&lang=ts"
export * from "./CompleteOtherForms.vue?vue&type=script&lang=ts"
import style0 from "./CompleteOtherForms.vue?vue&type=style&index=0&id=25c2aecb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports